export enum ContainerSizeType {
    SIZE10 = "SIZE10",
    SIZE20 = "SIZE20",
    SIZE30 = "SIZE30",
    SIZE40 = "SIZE40",
    SIZE45 = "SIZE45"
}
